import cn from 'classnames';
import React from 'react';

import deviceTypesService from '../../services/device/deviceTypesService';
import SignedImage from '../System/SignedImage';

const ProductImage = (props) => {
    const {mediaIdList, imgClassName, type, alt, isHolderSingle} = props;
    const deviceDefaultData = deviceTypesService.getDeviceTypesDataByType(type);
    const defaultImageUrl = deviceDefaultData
        ? isHolderSingle
            ? deviceDefaultData.defaultSingleHolder
            : deviceDefaultData.defaultImageSrc
        : null;

    return (
        <SignedImage
            isThumbnailAvailable
            alt={alt}
            mediaData={mediaIdList}
            defaultImage={defaultImageUrl}
            imgClassName={cn(
                'absolute max-w-none w-auto h-full top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2',
                imgClassName
            )}
        />
    );
};

export default ProductImage;
